import { Observable } from 'rxjs';
import {
  Preventivo,
  CreatePreventivoDto,
  UpdatePreventivoDto,
  PaginatedResponse,
  PreventiviQueryParams, DocumentoPreventivo,
} from '../../models/preventivi.model';
import {Capitolo} from '../../models/capitoli.model';

export abstract class PreventiviPort {
  abstract getList(params?: PreventiviQueryParams): Observable<PaginatedResponse<Preventivo>>;
  abstract getById(id: number): Observable<Preventivo>;
  abstract create(dto: CreatePreventivoDto): Observable<number>;
  abstract update(id: number, changes: UpdatePreventivoDto): Observable<number>;
  abstract delete(id: number): Observable<void>;
  abstract archive(id: number): Observable<number>;
  abstract unarchive(id: number): Observable<number>;
  abstract setAsRefused(id: number,  notaRifiuto?: string, dataRifiutato?: any): Observable<number>;
  abstract associateTo(id: number, idCantiere: number, dataAccettato: string): Observable<number>;
  abstract duplicate(id: number, idCliente: number): Observable<number>;

  abstract getDocumentiByPreventivo(
    idPreventivo: number
  ): Observable<DocumentoPreventivo[]>;

  abstract createDocumentoPreventivo(
    idPreventivo: number,
    file: File,
    descrizione?: string
  ): Observable<number>;

  abstract updateDocumentoPreventivo(
    id: number,
    descrizione?: string
  ): Observable<number>;

  abstract deleteDocumentoPreventivo(
    id: number
  ): Observable<void>;

  abstract previewFile(
    fileId: number
  ): Observable<Blob>;

  abstract getCapitoliByPreventivo(
    idPreventivo: number
  ): Observable<Capitolo[]>;

  abstract moveCapitolo(
    id: number,
    nuovoOrdine: number
  ): Observable<void>;

  abstract getSuggestionsCapitoli(
    nomeSearch: string,
    page?: number,
    size?: number
  ): Observable<PaginatedResponse<Capitolo>>;
}
